<template>
    <div>
        <svg :width="iconSize" :height="iconSize" viewBox="0 0 22 18" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path fill-rule="evenodd" clip-rule="evenodd"
                d="M21.5 10.3974C21.5 10.3974 19.8413 11.4565 16.8506 11.4565C13.7951 11.4565 11.6525 9.36922 11.6525 5.97465V5.9602C11.6525 2.61619 13.8093 0.5 16.8008 0.5C19.2296 0.5 20.3572 0.855227 21.23 1.87135L19.5036 3.39364C18.9631 2.79465 18.3356 2.47131 17.0928 2.55289C15.0565 2.68656 14.1156 3.72123 14.1156 5.93854V5.95298C14.1156 8.21362 15.5344 9.33481 17.2296 9.33481C18.6399 9.33481 19.3079 8.78209 19.3079 8.78209V7.09176H17.4815V4.93942H21.5V10.3974ZM0.5 11.1893H2.67238V4.52293V3.6928L7.28851 11.1893H10.2147V0.767232H7.9826V8.02644L3.59964 0.767232H0.5V11.1893ZM0.5 17.7647H1.78615V15.1123H1.85046L3.61248 17.7647H4.6607V12.5H3.37455V15.1123H3.31024L1.55786 12.5H0.5V17.7647ZM5.72852 17.7647H9.00177V16.5388H7.09184V15.6887H8.8828V14.5796H7.09184V13.7259H9.00177V12.5H5.72852V17.7647ZM11.1783 17.7647H9.73778L11.1043 15.1269V15.0977L9.73456 12.5H11.323L12.0528 14.1783H12.0786L12.8117 12.5H14.3229L12.8856 15.105V15.1342L14.3165 17.7647H12.7988L11.9982 16.1776H11.9725L11.1783 17.7647ZM15.7464 17.7647H17.1097V13.7259H18.3991V12.5H14.457V13.7259H15.7464V17.7647ZM20.2998 16.0757C20.8888 16.0757 21.2793 16.4 21.2793 16.8905C21.2793 17.4209 20.7929 17.7599 20.0301 17.7599H20.0268C19.274 17.7599 18.7793 17.4156 18.7793 16.8905C18.7793 16.4652 19.0771 16.1661 19.5305 16.0903L19.547 16.0876V16.3296L19.5305 16.3336C19.2227 16.412 19.0539 16.6047 19.0539 16.8905C19.0539 17.2707 19.4345 17.5153 20.0268 17.5153H20.0301C20.6307 17.5153 21.0046 17.2747 21.0046 16.8892C21.0046 16.5463 20.7316 16.315 20.3279 16.315H20.27V16.8533H20.0086V16.0757H20.2998ZM21.2234 15.6532V14.4648H20.9554V15.414H20.1347V14.514H19.87V15.414H19.104V14.4648H18.8359V15.6532H21.2234ZM21.2234 13.7947V14.0313H18.8359V13.7987L20.694 12.7579V12.7366H18.8359V12.5H21.2234V12.7326L19.372 13.7735V13.7947H21.2234Z"
                :fill="color" 
            />
        </svg>
    </div>
</template>

<script>
export default {
    name: 'IconSvgNextGen',
    props: {
        color: {
            type: String,
            default: '#000000',
        },
        size: {
            type: Number,
            default: null
        }
    },
    computed: {
        iconSize() {
            return this.size ? `${this.size}px` : '44px'
        }
    }
};
</script>

<style scoped></style>